import React, { useContext, useCallback, useEffect } from "react";
import { Input, Button, Form, Select, Row, Col, DatePicker } from "antd";
import { FiltersContext } from "@CONTEXTS";
import { Constants } from "@CONFIG";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
const { RangePicker } = DatePicker;
const Filters = () => {
  const { dispatch } = useContext(FiltersContext);

  const setFilters = useCallback(
    (obj) => {
      dispatch({
        type: "SET_FILTERS",
        payload: obj,
      });
    },
    [dispatch]
  );

  const onFinish = (values) => {
    const { invoiceType, search, dateRange } = values;

    const obj = {
      invoiceType,
      search,
      startDate: null,
      endDate: null,
    };

    if (dateRange) {
      obj.startDate = dateRange[0].format("YYYY-MM-DD");
      obj.endDate = dateRange[1].format("YYYY-MM-DD");
    }

    setFilters(obj);
  };

  useEffect(() => {
    resetFilters("all");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const resetFilters = (invoiceType) => {
    dispatch({
      type: "SET_FILTERS",
      payload: { invoiceType, search: null, dateRange: null },
    });
  };

  return (
    <Form layout="vertical" onFinish={onFinish} style={{ width: "100%" }}>
      <Row wrap={false} style={{ width: "100%" }} gutter={16}>
        <Col span={4}>
          <Form.Item
            name="invoiceType"
            label="Fatura Tipi"
            initialValue="all"
            style={{ marginBottom: 0 }}
          >
            <Select style={{ width: "100%" }}>
              <Select.Option value="all">TÜMÜ</Select.Option>
              <Select.Option value="unpaid">ÖDENMEYENLER</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="search" style={{ marginBottom: 0 }} label="Arama">
            <Input
              placeholder="Belge numarası / açıklamaya göre ara"
              prefix={<SearchOutlined />}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="dateRange"
            style={{ marginBottom: 0 }}
            label="Vade Tarihi"
          >
            <RangePicker
              style={{ width: 290 }}
              format={Constants.FORMATS.dateFormat}
              placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
              ranges={{
                "Geçen Hafta": [
                  moment().subtract(1, "week").startOf("week"),
                  moment().subtract(1, "week").endOf("week"),
                ],
                "Geçen Ay": [
                  moment().subtract(1, "month").startOf("month"),
                  moment().subtract(1, "month").endOf("month"),
                ],
                "Geçen Yıl": [
                  moment().subtract(1, "year").startOf("year"),
                  moment().subtract(1, "year").endOf("year"),
                ],
                Bugün: [moment(), moment()],
                "Son 1 Hafta": [moment().subtract(6, "days"), moment()],
                "Son 1 Ay": [moment().subtract(29, "days"), moment()],
                "Bu Yıl": [moment().startOf("year"), moment().endOf("year")],
              }}
            />
          </Form.Item>
        </Col>
        <Col
          span={8}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Form.Item style={{ width: 135, marginBottom: 0 }}>
            <Button type="primary" block htmlType="submit">
              Ara
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default Filters;
